import { useLocation, useNavigate } from 'react-router'
import { size } from '@styles/theme'
import styled from '@emotion/styled'
import ScreenContainer from '@screens/ScreenContainer'
import { ButtonBase, Modal } from '@mui/material'
import { PiX } from 'react-icons/pi'
import { useEffect, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

const CloseIcon = styled(PiX)`
  position: absolute;
  right: ${size(1)};
  top: ${size(1)};
  z-index: 100;
`

const Background = styled(ScreenContainer)`
  background-color: black;
  position: relative;
`

const ModalContainer = ({ renderCustomHeader, noHeader=false, open, animationExitDelay=300, animationClassNames='animation__modal', backgroundStyles={}, children }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const nodeRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    let timeout
    if(!open) {
      timeout = setTimeout(() => {
        setModalOpen(false)
        navigator?.virtualKeyboard?.hide()
      }, animationExitDelay)
    } else {
      setModalOpen(open)
    }
    return () => clearTimeout(timeout)
  }, [open])

  const goBack = () => navigate(-1)
  const goToBase = () => navigate(location?.pathname)

  const renderCloseButton = () => (
    <ButtonBase onClick={goBack}>
      <CloseIcon size={size(5)} />
    </ButtonBase>
  )

  return (
    // NOTE: This conditionally styled div helps the entrance animation to be less choppy
    //       on certain navigations, like back navigations between page transitions.
    <div style={{ backgroundColor: open ? 'black' : 'transparent' }}>
      <CSSTransition
        appear
        nodeRef={nodeRef}
        in={open}
        timeout={200}
        classNames={animationClassNames}>
        <Modal
          ref={nodeRef}
          open={open ? open : modalOpen}
          className={animationClassNames}>
          <Background style={backgroundStyles}>
            {!noHeader && (
                typeof renderCustomHeader === 'function'
                ? renderCustomHeader({ open, goBack, goToBase })
                : renderCloseButton()
              )
            }
            {children}
          </Background>
        </Modal>
      </CSSTransition>
    </div>
  )
}

export default ModalContainer
